import { Tip as _Tip } from "@/ui/Tip";
import { Container } from "react-bootstrap";

export default function ({ className = "bg-blue text-white mb-5", text }) {
  return (
    <Container>
      <_Tip className={className} text={text} />
    </Container>
  );
}
